import { useEffect, useRef, useState } from 'react'
import { Alert } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface Args {
  handleLogOut: () => void
}

export const useCheckSession = ({ handleLogOut }: Args) => {
  const [remainingTime, setRemainingTime] = useState<null | number>(null)
  const refInterval = useRef<NodeJS.Timeout | null>(null)

  const startCountdown = async () => {
    const startTime = new Date().getTime()
    const endTime = startTime + 24 * 60 * 60 * 1000

    await AsyncStorage.setItem('sessionEndTime', endTime.toString())

    updateCountdown(endTime)
  }

  const updateCountdown = async (endTime: number) => {
    refInterval.current = setInterval(() => {
      const currentTime = new Date().getTime()
      const timeLeft = endTime - currentTime

      if (timeLeft <= 0) {
        logout()
      } else {
        setRemainingTime(Math.floor(timeLeft / 1000))
      }
    }, 1000)
  }

  const checkSession = async () => {
    const sessionEndTime = await AsyncStorage.getItem('sessionEndTime')
    if (sessionEndTime) {
      const endTime = parseInt(sessionEndTime)
      const currentTime = new Date().getTime()

      if (currentTime >= endTime) {
        logout()
      } else {
        updateCountdown(endTime)
      }
    }
  }

  const stopInterval = () => {
    if (refInterval.current) {
      clearInterval(refInterval.current)
      refInterval.current = null
    }
  }

  const logout = async () => {
    await AsyncStorage.removeItem('sessionEndTime')
    Alert.alert('Sesión expirada', 'Has sido desconectado automáticamente.')
    stopInterval()
    handleLogOut()
  }

  useEffect(() => {
    checkSession()
  }, [])

  return { startCountdown, remainingTime, stopInterval }
}
